import React, { useState } from "react";

const SearchForm = ({ onSearch }) => {
  const [identif, setIdentif] = useState("");
  const [weight, setWeight] = useState(false);
  const [errors, setErrors] = useState({});
  
  const validateInputs = () => {
    const newErrors = {};
    const UnpRegex = /^(?:\d{9})$/;

    if (identif && !UnpRegex.test(identif)) {
      newErrors.identif = "Неверный формат УНП. Используйте '000000000' 9 цифр.";
    }

    if (!identif) {
      newErrors.general = "Введите УНП.";
    }
    return newErrors;
  };  

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length === 0) {
      onSearch(identif, weight);
      setErrors({}); 
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <div style={styles.inputGroup}>
        <label>Введите УНП заявителя (9 цифр):</label>
        <input
          type="text"
          value={identif.replace(/[^0-9]/g, '')}
          onChange={(e) => setIdentif(e.target.value.replace(/[^0-9]/g, ''))}
          placeholder="000000000"
          style={styles.input}
        />        
        {errors.identif && <p style={styles.error}>{errors.identif}</p>}
        <label for="weight_check">Разрешенный максимальный вес, включая вес прицепа (полуприцепа), составляет 3,5 тонны и более:</label>     
        <input
            type="checkbox"
            checked={weight}
            onChange={(e) => setWeight(e.target.checked)}
            name="weight_check"
          />           
      </div>      
      <button type="submit" style={styles.button}>Проверить</button>
    </form>
  );
};

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "400px",
    margin: "20px auto",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "10px",
    fontSize: "16px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
};

export default SearchForm;